import { Box, BoxProps, SystemStyleObject } from '@chakra-ui/react';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import ReactDatepicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export type DatePickerProps = {
  selectedDate: Date | undefined;
  onChange: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
  id?: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement, Element>) => void;
  sx?: BoxProps['sx'];
};

const selectStyle: SystemStyleObject = {
  color: 'text.title',
  bgColor: 'surface.control',
  borderRadius: '4px',
  px: '4px',
  py: '2px',
  mt: '10px',
};

// react-datepicker ships light-only CSS; remap its surfaces and text to
// color-mode-aware semantic tokens.
const colorModeStyle: SystemStyleObject = {
  '.react-datepicker': {
    bg: 'surface.card',
    borderColor: 'border.layout',
    color: 'text.body',
  },
  '.react-datepicker__header': {
    bg: 'surface.hover',
    borderColor: 'border.layout',
  },
  '.react-datepicker__current-month, .react-datepicker__day-name, .react-datepicker__day, .react-datepicker-time__header':
    {
      color: 'text.body',
    },
  '.react-datepicker__day:hover': {
    bg: 'surface.hover',
  },
  '.react-datepicker__day--disabled, .react-datepicker__day--outside-month': {
    color: 'text.muted',
  },
};

export const DatePicker = React.forwardRef<ReactDatepicker, DatePickerProps>(
  ({ selectedDate, onChange, id, onBlur, sx, minDate, maxDate }, ref) => {
    return (
      <Box
        sx={{
          ...sx,
          ...colorModeStyle,
          '.react-datepicker__month-select': selectStyle,
          '.react-datepicker__year-select': selectStyle,
        }}>
        <ReactDatepicker
          disabledKeyboardNavigation
          ref={ref}
          id={id}
          clearButtonTitle="clear"
          isClearable
          inline
          minDate={minDate}
          maxDate={maxDate}
          openToDate={selectedDate ?? undefined}
          selected={selectedDate}
          showMonthDropdown
          showYearDropdown
          onBlur={onBlur}
          dropdownMode="select"
          onChange={(updatedStart: Date | null) => {
            if (updatedStart) {
              onChange(updatedStart);
            }
          }}
        />
      </Box>
    );
  },
);

DatePicker.displayName = 'DatePicker';
